'use client'

import { useEffect, useState } from 'react';
import Image from 'next/image';

import { Base } from '@indxsearch/systm'
import styles from './Embeddable.module.css'

// icons
import {
  Terminal,
  Nodes, Feather, Cpu
} from "@indxsearch/pixl";
import FeatureIcon from '../components/FeatureIcon';

export default function Embeddable() {
  const [mounted, setMounted] = useState(false);
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    setMounted(true);

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    setIsDark(mediaQuery.matches);

    const handler = (e: MediaQueryListEvent) => setIsDark(e.matches);
    mediaQuery.addEventListener('change', handler);

    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  const embeddableImageSrc = `/images/embeddable${isDark ? '-dark' : ''}.svg`;

  return (
    <Base className={styles.base}>
      <div className={styles.baseinner}>
        <div className={styles.title}>
          <h2>Embeddable</h2>
          <p>Moves in with your .NET codebase</p>
          <ul>
            <li><FeatureIcon icon={<Nodes/>} label='Multiple instances'></FeatureIcon></li>
            <li><FeatureIcon icon={<Feather/>} label='< 1MB footprint'></FeatureIcon></li>
            <li><FeatureIcon icon={<Cpu/>} label='Multi-platform'></FeatureIcon></li>
          </ul>
        </div>
        <div className={styles.content}>
          <div className={styles.contentBox}>
            <div
              style={{
                width: '100%',
                aspectRatio: '316/228',
              }}
            >
              {mounted && (
                <Image
                  src={embeddableImageSrc}
                  alt="Illustration of a C# project folder structure with IndxSearchLib embedded as a Nuget package"
                  width={316}
                  height={228}
                  style={{ width: '100%', height: 'auto' }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </Base>
  )
}
